import ApiService from './ApiService';

class SystemContentApi extends ApiService {
    constructor() {
        super('system-contents');
    }

    getSystemContentByType(type: string) {
        return this.get(`by-type/${type}`);
    }
}

export default SystemContentApi;
